export default __webpack_public_path__ + "static/media/not_actice_order_report-hover.ab5a6fd7.svg";